import { FIELD_TYPES } from '../../../components/FormField'

export const FIELDS = [
  {
    label: 'Incident Type',
    name: 'incidentTypeId',
    type: FIELD_TYPES.INCIDENT_TYPE_LIST,
    defaultValue: 1,
  },
  {
    label: 'AI Layer',
    name: 'aiLayerId',
    type: FIELD_TYPES.AI_LAYERS_LIST,
    defaultValue: 1,
  },
  {
    label: 'Distance',
    name: 'distance',
    type: FIELD_TYPES.NUMBER,
    defaultValue: 5,
  },
  {
    label: 'Unit',
    name: 'unit',
    type: FIELD_TYPES.SELECT,
    options: [
      { label: 'Miles', value: 'miles' },
      { label: 'Feet', value: 'feet' },
    ],
    defaultValue: 'feet',
  },
]
